import Modal from '@stories/Components/Misc/Modal/Modal';
import VideoEmbed from '@stories/Components/Misc/VideoEmbed/VideoEmbed';
import React from 'react';
import { PastSeminarCardStyles as S } from './PastSeminarCard.styles';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
const PastSeminarCard = (props) => {
    const [modalOpen, setModalOpen] = React.useState(false);
    return (React.createElement(S.Container, null,
        props.video && (React.createElement(React.Fragment, null,
            React.createElement("noscript", null,
                React.createElement("div", { className: 'no-js-area' },
                    React.createElement(LinkButton, { href: `https://www.youtube.com/watch?v=${props.video.videoId}`, styleType: "underline", target: "_blank", backgroundPlacement: 'light', buttonSize: "large", title: `Visit YouTube to watch ${props.title}'s video` }),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(LinkButton, { href: `https://vimeo.com/${props.video.videoId}}`, styleType: "underline", target: "_blank", backgroundPlacement: 'light', buttonSize: "large", title: `Visit Vimeo to watch ${props.title}'s video` }))),
            React.createElement("div", { className: 'hide-no-js' },
                React.createElement(S.VideoWrapper, null,
                    React.createElement(S.Cta, { type: "button", "aria-label": "Open Video popup button", onClick: (event) => {
                            event.preventDefault();
                            setModalOpen(true);
                        } }),
                    React.createElement(VideoEmbed, { video: props.video }),
                    React.createElement(Modal, { ariaLabel: "Full Video Player Modal", isOpen: modalOpen, closeOnBackground: true, showBackground: true, showClose: true, onClose: () => {
                            setModalOpen(false);
                        } },
                        React.createElement(VideoEmbed, { video: props.video, autoplay: modalOpen })))))),
        props.caption && React.createElement(S.Caption, null, props.caption),
        React.createElement(S.Title, null, props.title),
        props.textContent && React.createElement(S.TextContent, null, props.textContent)));
};
export default PastSeminarCard;
